import clsx from "clsx";
import { FC, HTMLAttributes } from "react";

// --------------------------------------------------------------------------------------

export type IOfferSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  oldPrice?: string;
  newPrice?: string;
};

const OfferSection: FC<IOfferSectionProps> = (props) => {
  const { heading, oldPrice, newPrice, className, ...other } = props;

  return (
    <section
      className={clsx("py-5 dark:bg-black-900 lg:py-8 xl:py-[50px]", className)}
      {...other}
    >
      <div className="bg-gradient-to-b from-primary-900 to-secondary-900 px-4 py-8 text-center md:py-[50px]">
        {heading && (
          <h2 className="mb-5 text-h6 font-normal text-yellow-400 md:mb-7 lg:text-h5 xl:text-h4">
            {heading}
          </h2>
        )}
        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-5 lg:gap-7">
          {oldPrice && (
            <span className="text-h5 font-medium text-white line-through md:text-h4 md:font-semibold xl:text-h3">
              {oldPrice} /-
            </span>
          )}

          {newPrice && (
            <span className="text-h3 font-semibold text-white lg:text-3xl xl:text-h2">
              {newPrice} /-*
            </span>
          )}
        </div>
      </div>
    </section>
  );
};

export default OfferSection;
